import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Quiz from './Quiz';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { MODAL_USERS_ROOMS, showModal, MODAL_FORM_UPDATE_QUIZS } from '../../../../modules/modals';
import { connect } from 'react-redux'
import { getRoomStudents } from '../../actions';
import { MoreOutlined, TeamOutlined, CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';

class Room extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)

    let show = true;


    let showRoomQuiz = localStorage.getItem('showRoomQuiz');

    try {
      if(showRoomQuiz){
        showRoomQuiz = JSON.parse(showRoomQuiz);
        show = Boolean(showRoomQuiz[props.room.id])
      }
    } catch (error) {
      
    }


    this.state = {
      show
    }
  }

  changeShow = () => {
    const {show} = this.state;
    const {room} = this.props;

    try {
      let showRoomQuiz = localStorage.getItem('showRoomQuiz');

      if(showRoomQuiz){
        showRoomQuiz = JSON.parse(showRoomQuiz);
        showRoomQuiz[room.id] = !show;
      } else {
        showRoomQuiz = {[room.id]: !show}
      }
      localStorage.setItem('showRoomQuiz', JSON.stringify(showRoomQuiz))
    } catch (error) {
      
    }

    this.setState({show: !show});
  }
  
  render() {
    const { room, index, rooms } = this.props;
    const {formatMessage} = this.context
    const {show} = this.state;
    return (
      <Draggable draggableId={'room-'+ room.id} index={index} >
        {(provided) => (
        <div 
          
        >
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
                className={classNames("room", {'unassigned': room.id == -1})}
              >
                <div className="room-header" style={show ? {} : {borderBottom: 'none'}}  >
                  <div className="title">
                    <MoreOutlined />
                    <div {...provided.dragHandleProps}>
                      {room.title}
                    </div>
                  </div>
                  <div className="actions">
                    <div className="btn-student" onClick={async () => {
                      const {showModal, getData} = this.props;

                     
                      showModal({
                        modalType : MODAL_FORM_UPDATE_QUIZS,
                        modalProps : {
                          initialValues: {
                            color: "#2196f3",
                            room: room.id
                          },
                          rooms,
                          room,
                          getData,
                        }
                      })
                    }}>
                      <i style={{fontSize: 15}} className="fas fa-pen"></i>
                    </div>
                    <div className="btn-student" onClick={async () => {
                      const {showModal} = this.props;

                      const students = await getRoomStudents(room.id)
                      showModal({
                        modalType : MODAL_USERS_ROOMS,
                        modalProps : {
                          students: students,
                        }
                      })
                    }}>
                      <TeamOutlined />
                    </div>
                    <div className="btn-show-hide" onClick={this.changeShow}>
                      {show ? <CaretDownOutlined /> : <CaretUpOutlined />}
                    </div>
                  </div>
                  
                </div>
                 {show ? <Droppable droppableId={'room-'+room.id} type="quiz">
                    {(provided) => (
                        <div 
                          ref={provided.innerRef}
                          {...provided.droppableProps} 
                          className="room-body"
                        >
                          {room.quizs.map((quiz, index) => <Quiz key={quiz.id} deleteQuiz={this.props.deleteQuiz} index={index} quiz={quiz} />)}
                          {room.quizs.length == 0 ? <div style={{padding: 10}} className="error">{formatMessage('txtMessageClassroomHasNoQuizzes')}</div> : null}
                          {provided.placeholder}
                        </div>
                    )}
                  </Droppable> : null}
             </div>
        </div>
        )}
      </Draggable>
      
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  showModal
}

export default connect(mapStateToProps, mapDispatchToProps)(Room)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quizs/components/Room/index.jsx